export default __webpack_public_path__ + "static/media/view-feedback.21f269d5.svg";